<template>
  <a
    v-on:click.prevent.stop="submit()"
    @mouseenter="toggleStitchHover"
    @mouseleave="toggleStitchHover"
  >
    <HeartIcon
      width="26px"
      height="26px"
      :hovering="stitchHovering"
      :stitched="currentUserStitchedOutfit"
      class="heart-icon float-right"
    />
  </a>
</template>

<script>
import HeartIcon from "@/components/showCapsule/icons/Heart";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    HeartIcon,
  },

  data() {
    return {
      stitchHovering: false,
    };
  },

  props: {
    capsuleId: {
      type: Number,
      required: true,
    },
    outfitId: {
      type: Number,
      required: true,
    },
    outfitTitle: {
      type: String,
      required: true,
    },
    currentUserStitchedOutfit: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    ...mapActions(["createOutfit", "destroyOutfit"]),

    submit() {
      this.currentUser !== null
        ? this.submitStitchOutfit()
        : bus.$emit("openSignUpModal");
    },

    submitStitchOutfit() {
      const payload = {
        capsuleId: this.capsuleId,
        outfitId: this.outfitId,
        title: this.outfitTitle,
      };

      this.currentUserStitchedOutfit
        ? this.destroyOutfit(payload).then(() =>
            this.trackEvent("destroy", payload)
          )
        : this.createOutfit(payload).then(() => {
            this.trackEvent("create", payload);
            this.$parent.$parent.$parent.$parent.$refs.outfitTitleBar.scrollIntoView();
          });
    },

    trackEvent(actionName, { capsuleId, outfitId, title }) {
      window.analytics.track(
        `Show Capsule Page - Stitch Button: ${actionName}`,
        {
          outfit_id: outfitId,
          outfit_title: title,
          capsule_id: capsuleId,
          user_id: this.currentUser.id,
        }
      );
    },

    toggleStitchHover() {
      this.stitchHovering = !this.stitchHovering;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/StitchButton.vue